import React from "react";
import getConfig from "next/config";
import { Form } from "react-bootstrap";
import Typography from "@mui/material/Typography";

const { publicRuntimeConfig } = getConfig();

export default function OfficeActionRushProcessing({ onChange, trademarkRushProcessing, state }) {
  return (
    <div className="rush-processing">
      <img src={`${publicRuntimeConfig.basePath}/clock-icon.png`} alt="" layout="fill" />
      <div className="copy">
        <div className="optional"></div>
        <h2>
          Rush priority processing.
          <br /> Next day processing when you need your copyright filed quickly.
        </h2>
        <Typography className="regular">
          We will process your application and send it to you for review and approval by the next business day. This is for when you need your filing done fast. This means we move your application to the top of our list and get it done quickly. It does not mean that the U.S. Copyright Office will take any actions or respond to your filing any quicker.
        </Typography>
        <Form.Group controlId="rushProcessing">
          <Form.Check
            type="checkbox"
            className="text-left"
            checked={state.rushProcessing === true}
            name="rushProcessing"
            onChange={onChange}
            label={
              <>
                <span className="required">*</span>
                <span className="hour-24">24-hour Expedited Processing (Next Business Day):</span>&nbsp;
                <span className="price">{"$" + trademarkRushProcessing?.price?.toFixed(2) + " USD"}</span>
              </>
            }
          />
        </Form.Group>
      </div>
    </div>
  );
}
